import React, { useEffect, useState } from "react";
import './ContextMenu.css';
import { getHotkeyStore, processMouseCommand } from '../../store/hotkeyStore';
import { usePlayerStore } from '../../store/store';

function UserListMenu({ x, y, sendMessage, details, index, hideMenu }) {
    const [mouseOptions, setMouseOptions] = useState([]);
    
    // Get player info for character ID
    const playerInfo = usePlayerStore((state) => state.pInfo);
    const characterId = playerInfo?.name;

    // Load mouse options from store
    useEffect(() => {
        if (characterId) {
            const store = getHotkeyStore(characterId);
            if (store) {
                const storedMouseOptions = store.getState().mouseOptions;
                if (storedMouseOptions && storedMouseOptions.length > 0) {
                    setMouseOptions(storedMouseOptions);
                }
            }
        }
    }, [characterId]);

    // Get the target identifier (name for players, index for mobs)
    const getTarget = () => {
        return details.type === 'player' ? details.name : index;
    };

    const executeCommand = (e, command) => {
        e.preventDefault();
        e.stopPropagation();
        hideMenu();
        
        // Process the command to replace {target} with actual target
        const target = getTarget();
        const processedCommand = processMouseCommand(command, target, details.name);
        if (processedCommand) {
            sendMessage('600' + processedCommand);
        }
    };

    const doAttack = (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideMenu();
        const target = getTarget();
        sendMessage('600/a ' + target);
    };

    const doExamine = (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideMenu();
        const target = getTarget();
        sendMessage('600/examine ' + target);
    };

    const doPartyInvite = (e, name) => {
        e.preventDefault();
        e.stopPropagation();
        hideMenu();
        sendMessage('600/party invite ' + name);
    };
    
    const doTradeInvite = (e, name) => {
        e.preventDefault();
        e.stopPropagation();
        hideMenu();
        sendMessage('600/trade invite ' + name);
    };

    // Filter out empty mouse options
    const validMouseOptions = mouseOptions.filter(option => option.name && option.cmd);

    return (
        <div className="context-menu" style={{ left: x + 'px', top: y + 'px' }}>
            <ul>
                <li onClick={doAttack}>Attack {details.name}</li>
                <li onClick={doExamine}>Examine {details.name}</li>
                <li onClick={(e) => { e.preventDefault(); e.stopPropagation(); hideMenu(); sendMessage('600/t ' + getTarget() + " hi"); }}>Chat</li>
                
                {/* Display custom mouse options */}
                {validMouseOptions.length > 0 && (
                    <>
                        <li className="context-menu-divider"></li>
                        {validMouseOptions.map((option) => (
                            <li 
                                key={option.key} 
                                onClick={(e) => executeCommand(e, option.cmd)}
                                className="mouse-option"
                            >
                                {option.name}
                            </li>
                        ))}
                    </>
                )}
                
                {details.type !== 'mob' && (
                    <>
                        <li className="context-menu-divider"></li>
                        <li onClick={(e) => doPartyInvite(e, details.name)}>Invite to Party</li>
                        <li onClick={(e) => doTradeInvite(e, details.name)}>Invite to Trade</li>
                    </>
                )}
            </ul>
        </div>
    );
}

//attack
//examine
//chat
//------
//invite to party
//invite to trade
//custom

export default UserListMenu;